<div class="leads-top-filters-fields">
    <div class="leads-top-filter-holder">
        <label class="padded-top-gray-label">Customer Type:</label>
        <ng-select
            [(ngModel)]="selectedCustomerType"
            [ngModelOptions]="{ standalone: true }"
            [clearable]="true"
            [clearOnBackspace]="true"
            [searchable]="false"
            placeholder="Select Customer Type">
            <ng-option
                *ngFor="let customerType of customerTypes"
                [value]="customerType.id">
                {{ customerType.name }}
            </ng-option>
        </ng-select>
    </div>
    <div class="leads-top-filter-holder">
        <label class="padded-top-gray-label">Lead Type:</label>
        <ng-select
            [(ngModel)]="selectedLeadType"
            [ngModelOptions]="{ standalone: true }"
            [clearable]="true"
            [clearOnBackspace]="true"
            [searchable]="false"
            placeholder="Select Lead Type">
            <ng-option
                *ngFor="let leadType of leadTypes"
                [value]="leadType.value">
                {{ leadType.name }}
            </ng-option>
        </ng-select>
    </div>
    <div class="leads-top-filter-holder">
        <label class="padded-top-gray-label">Select Manager:</label>
        <ng-select
            [(ngModel)]="selectedAdmin"
            [ngModelOptions]="{ standalone: true }"
            [clearable]="true"
            [clearOnBackspace]="true"
            [searchable]="false"
            placeholder="Enter Admin Users">
            <ng-option
                *ngFor="let admin of admins"
                [value]="admin.id">
                {{ admin.name }}
            </ng-option>
        </ng-select>
    </div>
    <div class="leads-top-filter-holder">
        <app-smart-date-selection
            [rangeType]="ESmartDateSelectionRangeType.CurrentFinancialYear"
            [oneInputField]="true"
            [setInitRange]="false"
            [clearable]="true"
            (dateRangeSelected)="dateRangeChanged($event)"></app-smart-date-selection>
    </div>
</div>
<div class="leads-top-filters-buttons">
    <button
        class="btn-styled--secondary"
        type="button"
        (click)="resetFilters()">
        Reset Filters
    </button>
    <button
        class="btn-styled"
        type="button"
        (click)="applyFilters()">
        Apply Filters
    </button>
</div>
